<template>
  <div class="first_page section section_bg">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <section v-if="is_load"  class="">

      <div class="container mobile_div  pt-2 pb-2">
        <div class="section_header no_margin mobile_div back_div_element"  >
          <router-link tag="a" class="btn" :to="{name: 'rewards'}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>



        <div class=" second_section mt-2 mb-4  col-12" >
          <div class=" mt-2 mb-4  col-12">
            <h2 class="text-center">{{ reward.title }}</h2>
            <p class="text-center">Всего выдано {{ total}} ( {{ percent}} %)</p>

          </div>

          <div v-if="reward.my_award" class="col-12 mt-4  d-flex justify-content-center  w-100 image__picture--with-background">
            <div class="img_div ">
              <v-lazy-image :src="reward.image" class="img-fluid mx-auto img-thumbnail image__picture--stretched" />
            </div>
          </div>
          <div v-if="reward.my_award" class="post_material_mini_content">
            <editorjsrender ref="editorjsrender" :blocks_json="reward.content.blocks"></editorjsrender>
          </div>
          <p v-if="!reward.my_award" class="text-center">Увы, но вы еще не открыли эту награду!</p>


        </div>

      </div>

    </section>
  </div>
</template>

<script>
import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import VLazyImage from "v-lazy-image/v2";

export default {
  name: "RewardOne",
  components: {LoadingBlock,VLazyImage},
  data() {
    return {
      "is_load":false,
      "reward":null,
      'total':0,
      'percent':0,

    }
  },
  mounted(){
    var app=this;
    app.startLoading();
  },
  methods:{
    startLoading() {
      var app = this;
      let id = app.$route.params.id;
      Api.loadReward(id,function(data){
        app.reward=data.reward;
        app.percent=data.percent;
        app.total=data.total;
        app.is_load=true;

      })
    }
  }
}
</script>

<style scoped>

</style>